import React from "react";
import cn from "classnames";

import { Select } from "src/shared/ui/Select";
import useStores from "src/hooks/useStores";
import { GameCreateFen } from "src/store/models";
import { gameModeText } from "src/store/gameStore/constants/gameModeConst";

import { useStyles } from "./styles";
import { useLocale } from "../../../../providers/LocaleProvider";

export const TypeSelect = () => {
    const classes = useStyles();
    const { lobbyStore } = useStores();
    const typeGameConfig = lobbyStore.gameModeConfig.value;
    const {
        lobby: {
            gameType: { classic: {classicName} },
        },
    } = useLocale();

    const options = [
        {
            value: GameCreateFen.classic,
            label: classicName(gameModeText[GameCreateFen.classic]),
        },
        {
            value: GameCreateFen.nineHundredSixty,
            label: gameModeText[GameCreateFen.nineHundredSixty],
        },
    ];

    return (
        <Select<number>
            value={typeGameConfig}
            onChange={(value) => {
                lobbyStore.setGameModeConfigValue(value);
            }}
            options={options}
            renderEmptyLabel={() => {
                return <div>Empty</div>;
            }}
            renderLabel={(option) => {
                return (
                    <div className={classes.betSelectLabelWrapper}>
                        <span className={classes.betSelectLabel}>
                            {option.label}
                        </span>
                    </div>
                );
            }}
            renderOption={(option, selected) => {
                return (
                    <div
                        className={cn(classes.betOption, {
                            [classes.betOptionSelected]: selected,
                        })}
                    >
                        <span className={classes.betDropdownOptionLabel}>
                            {option.label}
                        </span>
                    </div>
                );
            }}
        />
    );
};
